import type { SVGProps } from 'react';

interface SubMenuArrowIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function SubMenuArrowIcon({ className, ...props }: SubMenuArrowIconProps) {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M7.69922 6.64453L1.36164 13.0525C1.04268 13.375 0.519045 13.366 0.211381 13.0327C-0.0757029 12.7217 -0.0690252 12.2404 0.226575 11.9374L5.39153 6.64453L0.226576 1.35162C-0.0690242 1.0487 -0.0757018 0.567361 0.211382 0.256354C0.519046 -0.0769488 1.04268 -0.0859702 1.36164 0.236536L7.69922 6.64453Z"
        fill="currentColor"
      />
    </svg>
  );
}
